import React from 'react'
import LineTabButton from './LineTabButton';

const tabMap = {
    days_5: '5D',
    month: '1M',
    month_6: '6M',
    year_1: '1Y',
    year_5: '5Y',
    ytd_weekly: 'YTD'
}

const LineTabs = ({ tabs, activeTab, setActiveTab, color }) => {
    return (
        <div style={{ display: 'flex', width: '80%' }}>
            {tabs.map((tab, index) => {
                return (
                    <div style={{ flex: '1 1 auto', textAlign: 'center' }} key={index}>
                        <LineTabButton tab={tab} activeTab={activeTab} color={color} handleOnClick={() => setActiveTab(tab)}>
                            {tabMap[tab]}
                        </LineTabButton>
                    </div>
                )
            })}
        </div>
    )
}

export default LineTabs;